import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { HiMenuAlt2, HiX } from 'react-icons/hi';
import { usePlayer } from './PlayerContext';
import './Layout.css';

const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const { showPlayer, setEmbedContainer } = usePlayer();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    return (
        <div className="layout-container">
            {/* Mobile Header */}
            <div className="mobile-header">
                <button className="menu-toggle" onClick={toggleSidebar} aria-label="Toggle menu">
                    {isSidebarOpen ? <HiX size={24} /> : <HiMenuAlt2 size={24} />}
                </button>
                <Link to="/" className="mobile-title">Divyesh Thirukonda</Link>
            </div>

            <div className="layout-body">
                {/* Sidebar Overlay for Mobile */}
                <div
                    className={`sidebar-overlay ${isSidebarOpen ? 'open' : ''}`}
                    onClick={closeSidebar}
                />

                {/* Sidebar */}
                <div className={`sidebar-wrapper ${isSidebarOpen ? 'open' : ''}`}>
                    <Sidebar onNavigate={closeSidebar} />
                </div>

                {/* Main Content */}
                <main className="main-content">
                    {children}
                </main>
            </div>

            {/* Spotify Player - controlled via iFrame API (hidden but functional) */}
            {showPlayer && (
                <div className="spotify-player-container">
                    <div ref={setEmbedContainer} id="spotify-embed"></div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default Layout;
